<template>
  <img
    v-if="marker?.cover_photo?.icon && !marker.isHovered && !onlyMarker && load"
    :src="marker?.cover_photo?.icon"
    class="pin"
  />
  <div
    v-else
    :class="['without-img-pin', { active: marker.isHovered || onlyMarker }]"
  >
    <IconBase
      class="icon"
      name="location-20-icon-old"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';

  import IconBase from '@/shared/icons/IconBase.vue';
  import { type CityTagsAdvanced } from '@/shared/models/types';

  const props = defineProps<{
    marker: CityTagsAdvanced;
    onlyMarker: boolean;
  }>();

  const load = ref(true);

  onMounted(() => {
    const img: HTMLImageElement = new Image();

    if (props.marker.cover_photo?.icon) {
      img.src = props.marker.cover_photo.icon;
      img.onerror = () => {
        load.value = false;
      };
    } else {
      load.value = false;
    }
  });
</script>

<style lang="scss" scoped>
  .pin,
  .without-img-pin {
    position: relative;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background: var(--alias-color-icon-default);
    border: 1px rgb(255 255 255) solid;
    border-radius: 50%;
  }

  .without-img-pin {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .active {
    background: var(--alias-color-icon-accent-magenta);
  }
</style>
